import React from 'react';

import { TBlock } from '@wp-block-builder/package';

import { TColumnsSectionBlock } from '../';
import StackedTableCell from '../StackedTableCell';
import useBlockProps from '../useBlockProps';

type TChildBlockRenderer = (block: TBlock | null, index: number) => JSX.Element;

type Props = {
  block: TColumnsSectionBlock;
  renderChildBlock: TChildBlockRenderer;
};
export default function MobileBlockLayout({ block, renderChildBlock }: Props) {
  const blockProps = useBlockProps(block);
  if (blockProps.mobileLayout !== 'stacked') {
    return null;
  }

  if (blockProps.columnsCount === 3) {
    return (
      <>
        <StackedTableCell index={0} blockProps={blockProps} renderChildBlock={renderChildBlock} />
        <StackedTableCell index={1} blockProps={blockProps} renderChildBlock={renderChildBlock} />
        <StackedTableCell index={2} blockProps={blockProps} renderChildBlock={renderChildBlock} />
      </>
    );
  }
  return (
    <>
      <StackedTableCell index={0} blockProps={blockProps} renderChildBlock={renderChildBlock} />
      <StackedTableCell index={1} blockProps={blockProps} renderChildBlock={renderChildBlock} />
    </>
  );
}
